import {
  FETCH_SHIFT_CATEGORIES,
  FETCH_SHIFT_CATEGORIES_SUCCESS,
  SHIFT_CATEGORY_NAME,
  SHIFT_CATEGORY_ORDER,
  SHIFT_CATEGORY_SHIFT_TYPE,
  SHIFT_CATEGORY_DESCRIPTION,
  SHIFT_CATEGORY_SUBMIT_FORM,
  SHIFT_CATEGORY_ACTION_SUCCESS,
  SHIFT_CATEGORY_EDIT,
  SHIFT_CATEGORY_EDIT_SUBMIT_FORM,
  SHIFT_CATEGORY_DELETE,
  SHIFT_CATEGORY_DIALOG_BOX_STATUS,
  SHIFT_CATEGORY_SET_DELETE_ID,
  GET_SHIFTS,
  GET_SHIFTS_SUCCESS,
} from "../constants/shiftCategories.constants";

export const getShiftCategories = (page) => {
  return {
    type: FETCH_SHIFT_CATEGORIES,
    page: page,
  };
};

export const getShiftCategoriesSuccess = (shift_categories) => {
  return {
    type: FETCH_SHIFT_CATEGORIES_SUCCESS,
    shift_categories: shift_categories,
  };
};

export const onChangeShiftCategoryName = (shift_category_name) => {
  return {
    type: SHIFT_CATEGORY_NAME,
    shift_category_name: shift_category_name,
  };
};

export const onChangeShiftCategoryOrder = (shift_category_order) => {
  return {
    type: SHIFT_CATEGORY_ORDER,
    shift_category_order: shift_category_order,
  };
};

export const onChangeShiftCategoryShiftType = (shift_category_shift_type) => {
  return {
    type: SHIFT_CATEGORY_SHIFT_TYPE,
    shift_category_shift_type: shift_category_shift_type,
  };
};

export const onChangeShiftCategoryDescription = (shift_category_description) => {
  return {
    type: SHIFT_CATEGORY_DESCRIPTION,
    shift_category_description: shift_category_description,
  };
};

export const onSubmitShiftCategoryForm = (new_shift_category_data) => {
  return {
    type: SHIFT_CATEGORY_SUBMIT_FORM,
    shift_category_data: new_shift_category_data,
  };
};

export const shiftCategoryActionSuccess = (shift_categories) => {
  return {
    type: SHIFT_CATEGORY_ACTION_SUCCESS,
    shift_categories: shift_categories,
  };
};

export const shiftCategoryEdit = (shift_category_id) => {
  return {
    type: SHIFT_CATEGORY_EDIT,
    shift_category_id: shift_category_id,
  };
};

export const onSubmitShiftCategoryEditForm = (new_shift_category_data, page) => {
  return {
    type: SHIFT_CATEGORY_EDIT_SUBMIT_FORM,
    shift_category_data: new_shift_category_data,
    page: page,
  };
};

export const shiftCategoryDelete = (shift_category_id) => {
  return {
    type: SHIFT_CATEGORY_DELETE,
    shift_category_id: shift_category_id,
  };
};

export const changeShiftCategoryDialogBoxStatus = (status) => {
  return {
    type: SHIFT_CATEGORY_DIALOG_BOX_STATUS,
    status: status,
  };
};

export const changeShiftCategoryDeleteId = (delete_id) => {
  return {
    type: SHIFT_CATEGORY_SET_DELETE_ID,
    delete_id: delete_id,
  };
};

export const getShifts = () => {
  return {
    type: GET_SHIFTS
  };
};

export const getShiftsSuccess = (shift_data) => {
  return {
    type: GET_SHIFTS_SUCCESS,
    shift_data: shift_data,
  };
};